import React from "react"
import EngineIDNavBar from "@components/EngineIDNavBar"
import Banner from "./Banner"
import FeaturesSection from "./FeaturesSection"
import CTASignUpLong from "@components/CTASignUpLong"
import Footer from "@components/Footer"
import "./index.scss"
import "@styles/global.scss"
import "@styles/custom-bootstrap.scss"

const Features = props => {
  return (
    <div>
      <EngineIDNavBar />
      <Banner />
      <div className={"container-fluid"}>
        <div className={"maxWidth"}>
          <FeaturesSection></FeaturesSection>
        </div>
      </div>
      <CTASignUpLong />
      <Footer />
    </div>
  )
}

export default Features
